<template>
  <FlatActionButton
    :action="() => handleClick(item)"
    :class="['btnTransparent', 'btnWithoutShadow', 'btnTextLink']"
  >
    {{ text }}
  </FlatActionButton>
</template>

<script>
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'ItemLink',

  components: {
    FlatActionButton,
  },

  props: {
    handleClick: {
      type: Function,
      required: true,
    },
    item: {
      default: () => ({}),
      type: Object,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
